


























































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";

import {
  PossibleExpense,
  TransactionToRemove,
  ExpenseEligibility,
  ExpenseEligibilityGroup,
  ReimbursementType
} from "@/shared/types";

import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import ReimbursedExpenseChildRow from "@/shared/components/expense/ReimbursedExpenseChildRow.vue";
import { useExpenseReimbursedStore } from "@/employee/store/expenseReimbursed";

@Component({
  components: {
    Pill,
    CurrencyAmount,
    ReimbursedExpenseChildRow
  }
})
export default class ReimbursedRow extends Vue {
  reimbursedStore = useExpenseReimbursedStore();

  @Prop()
  reimbursementAmount: number;

  @Prop()
  expenseId: number;

  @Prop()
  createdDate: string;

  @Prop()
  numberOfExpenses: number;

  @Prop()
  childExpenses: any[];

  @Prop()
  isSelected: boolean;

  @Prop()
  isReimbursementPosted: boolean;

  @Prop()
  description: string;

  @Prop()
  reimbursementType: string;

  @Prop()
  childExpenseLoaded: boolean;

  @Prop()
  expenseAmount: number;

  @Prop()
  collapseRow: () => void;

  @Prop()
  dateReimbursed: string;

  isOpen = false;
  ExpenseEligibilityGroup = ExpenseEligibilityGroup;
  formatCurrency = formatCurrency;

  toggleOpen (e): void {
    e.preventDefault();
    this.isOpen = !this.isOpen;
    this.reimbursedStore.loadExpensesForReimbursement(this.expenseId);
  }

  onEditClose (): void {
    this.isOpen = false;
    if (this.collapseRow) {
      this.collapseRow();
    }
  }

  get reimbursedStatus (): string {
    return this.isReimbursementPosted ? this.reimbursementTypeName : "Pending";
  }

  get reimbursementTypeName (): string {
    switch (this.reimbursementType) {
      case ReimbursementType.DebitCard:
        return "HSA debit card";
      case ReimbursementType.Disbursement:
        return "Disbursed";
      default:
        return "Reimbursed";
    }
  }

  get reimbursementDescription (): string {
    return this.description ? this.description : "Reimbursement";
  }

  get expensesDisplayCopy (): string {
    if (this.numberOfExpenses > 1) {
      return `${this.numberOfExpenses} expenses totaling ${this.formatCurrency(this.expenseAmount)}`;
    } else if (this.numberOfExpenses === 0) {
      return `${this.numberOfExpenses} expenses`;
    }

    return `${this.numberOfExpenses} expense totaling ${this.formatCurrency(this.expenseAmount)}`;
  }

  get formattedDate (): string {
    if (this.dateReimbursed) {
      return moment(this.dateReimbursed).format("MMM D, YYYY");
    } else {
      return moment(this.createdDate).format("MMM D, YYYY");
    }
  }

  get displayUnaccountedExpenseRow (): boolean {

    // display if there are no child expenses, or the child expenses don't equal the reimbursed amount
    return (!this.childExpenses || !this.childExpenses.length ||
        _.round(_.sumBy(this.childExpenses, "reimbursedAmount"), 2) !== this.reimbursementAmount);
  }

  get unaccountedExpenseProps (): any {
    const reimbursedAmount = this.reimbursementAmount - _.round(_.sumBy(this.childExpenses, "reimbursedAmount"), 2);

    return {
      name: "Undocumented Amount",
      expenseCategory: "medical",
      reimbursedAmount,
      date: this.createdDate,
      id: 0
    };
  }
}

